import { FormInputInputType } from '@src/core/buyerApiClient';
import { BRAZIL_PHONE_DDI, normalizeIdentity } from '@src/domains/customers';
import { FormInputValue } from '@src/domains/orders/core/form-inputs/types';
import { formInputDateToIso } from '@src/domains/orders/core/form-inputs/formInputDate';

const CPF_FORMAT_RULE = 'cpf_format';

/**
 * Both forms use the design system's `PhoneInput`, which returns E164 with the ddi the
 * buyer picked — any leading `+` is already a country, and prefixing it again would
 * send a chilean number as `+55+56...`. A number without it is a national one, and the
 * ddi has to be added here.
 *
 * Dates: the new form masks them as `dd/mm/yyyy` and the Core only takes `yyyy-mm-dd`.
 * The legacy form uses the native date input, which already hands over `yyyy-mm-dd`.
 *
 * CPF: the new form masks it as `000.000.000-00` and the legacy one shows that mask as
 * placeholder, so the buyer types it too. Sellers usually pair `cpf_format` with
 * `numeric`, and the Core checks `numeric` on the raw value — only the digits go.
 */
export const normalizeFormInputValue = (
  formInputValue: FormInputValue,
  validationRules?: string[] | null,
): FormInputValue => {
  const { inputType, value } = formInputValue;

  if (inputType === FormInputInputType.Phone && !value.startsWith('+') && value) {
    return { ...formInputValue, value: `${BRAZIL_PHONE_DDI}${value}` };
  }

  if (inputType === FormInputInputType.Date) {
    return { ...formInputValue, value: formInputDateToIso(value) };
  }

  // Phones and dates keep their own format even when `cpf_format` was put on them by mistake.
  if (inputType !== FormInputInputType.Phone && validationRules?.includes(CPF_FORMAT_RULE)) {
    return { ...formInputValue, value: normalizeIdentity(value) };
  }

  return formInputValue;
};
